/* global viewProjectActivityDetailsUrl */

import React from 'react';

import classNames from 'classnames';
import moment from 'moment/moment';

export default function ActionSummaryTable(props) {
    const viewProjectActivityDetails = (activityId) => {
        window.location.href = viewProjectActivityDetailsUrl.replace('ACTIVITY_ID', activityId);
    };

    return (
        <div id="super-milestones-table" className="inbud-table_wrapper">
            <table className="inbud-table tw-table-fixed">
                <thead>
                    <tr>
                        <th>{$t('Description')}</th>
                        <th>{$t('Action Owner')}</th>
                        <th>{$t('Due date')}</th>
                        <th>{$t('Completion Date')}</th>
                        <th>{$t('Activity')}</th>
                        <th>{$t('Activity Owner')}</th>
                        <th>{$t('Category')}</th>
                    </tr>
                </thead>
                {!props.isLoading && (
                    <tbody>
                        {props.actionSummary.map((action) => (
                            <tr key={`action-${action.id}`}>
                                <td>{action.description}</td>
                                <td>
                                    {action.owner?.first_name} {action.owner?.last_name}
                                </td>
                                <td className="inbud-date-cell">{action.date ? moment(action.date).format('YYYY-MM-DD') : ''}</td>
                                <td className="inbud-date-cell">{action.completed_date ? moment(action.completed_date).format('YYYY-MM-DD') : ''}</td>
                                <td className="tw-cursor-pointer" onClick={() => viewProjectActivityDetails(action.actionable.id)}>
                                    <div className="tw-flex tw-flex-row tw-gap-x-3 tw-items-center">
                                        <div
                                            className={classNames('tw-min-w-4', 'tw-w-4', 'tw-h-4', 'tw-rounded-md', {
                                                'tw-bg-red-500': action.actionable.rag_status === 'red' && action.actionable.status_label !== 'Complete',
                                                'tw-bg-amber-500': action.actionable.rag_status === 'amber' && action.actionable.status_label !== 'Complete',
                                                'tw-bg-green-500': action.actionable.rag_status === 'green' && action.actionable.status_label !== 'Complete',
                                                'tw-bg-blue-500': action.actionable.status_label === 'Complete',
                                            })}
                                        ></div>
                                        {action.actionable.description}
                                    </div>
                                </td>
                                <td>
                                    {action.actionable?.owner?.first_name} {action.actionable?.owner?.last_name}
                                </td>
                                <td>{action.actionable.category.description}</td>
                            </tr>
                        ))}
                    </tbody>
                )}
                {props.isLoading && (
                    <tbody>
                        <tr>
                            <td colSpan="7">{$t('Loading')}...</td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>
    );
}
